<div class="content-header">
  <h1>Transactions Management</h1>
</div>
<div class="filters">
  <div class="filters-grid">
    <div class="filter-control event-filter">
      <sdc-input
        label="Events"
        name="transaction-event-search"
        placeholder="Search events"
        [control]="eventSearchControl" />
    </div>
    <div class="filter-control account-filter">
      <sdc-input
        label="Account"
        name="transaction-account"
        [control]="accountFilterControl" />
    </div>
    <div class="filter-control status-filter">
      <sdc-select
        label="Status"
        name="transaction-status"
        [options]="statusOptions"
        [control]="statusFilterControl" />
    </div>
    <div class="filter-control date-range-filter">
      <sdc-daterange
        label="From / To"
        [range]="dateRange"
        (rangeChange)="onDateRangeChange($event)" />
    </div>

    <div class="filter-control event-select-filter">
      @if (eventOptions.length) {
        <sdc-select
          name="transaction-event"
          placeholder="Select Event"
          [options]="filteredEventOptions"
          [control]="eventFilterControl" />
      }
    </div>
    <div id="topbar-btns" class="filter-actions">
      <sdc-button variant="glass" (onClick)="submit()">
        <span>Search</span>
        <ng-icon name="lucideSearch" aria-hidden="true" />
      </sdc-button>
      <sdc-button variant="secondary" (onClick)="reset()">Clear</sdc-button>
    </div>
  </div>
</div>

<gs-table [data]="data" [columns]="columns" [loading]="loading()"></gs-table>

<div class="pagination-container">
  <app-pagination
    class="paginator"
    [currentPage]="currentPage"
    [totalItemsInDb]="totalItemsInDb"
    [itemsPerPage]="itemsPerPage"
    #pagination></app-pagination>
  <div class="export-container">
    <sdc-button variant="success" class="export-csv" (onClick)="exportAsCsv()">
      Export transactions
    </sdc-button>
  </div>
</div>
